import type { I_apiGetProducts, I_apiGetProducts_Return } from "./apiGetProducts.types";

import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

const apiGetProducts: I_apiGetProducts = async (aboutProducts) => {
    const fetchData = await axios.post<I_apiGetProducts_Return>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/calc/products`,
        aboutProducts,
    );
    // console.log(fetchData.data);
    return fetchData.data;
};

export default apiGetProducts;
